module.exports = __webpack_public_path__ + "static/media/Group7.46d74679.png";